import React from 'react';

import { Flex } from '@/new_src/view/components/Flex';
import { Text } from '@/new_src/view/components/Text';

import Button from 'components/ui/Button';
import { translate } from 'utils/LocaleUtil';

import Modal from '../../ui/Modal';
import { type StatusType } from '../../ui/Modal/ModalHeader';

// 레거시 모달의 z-index 보다 1 높게 설정
const Z_INDEX = 801;

type AlertProps = {
  title?: string;
  open: boolean;
  status?: StatusType;
  cancelButtonLabel?: string;
  confirmButtonLabel?: string;
  confirmButtonColor?: 'blue' | 'red';
  showCancelButton?: boolean;
  showConfirmButton?: boolean;
  html?: React.ReactNode;
  size?: 'xs' | 'sm';
  onClose: () => void;
  onConfirm?: () => void;
};

/**
 * @description
 * 알림용 모달 (경고, 확인, 정보 등)
 */
const Alert = ({
  title,
  open,
  status,
  cancelButtonLabel = translate('cancel'),
  confirmButtonLabel = translate('confirm'),
  confirmButtonColor = 'blue',
  showCancelButton = true,
  showConfirmButton = true,
  html,
  size = 'sm',
  onClose,
  onConfirm,
}: AlertProps) => {
  return (
    <Modal gap={html ? 0 : 12} size={size} open={open} onClose={onClose} zIndex={Z_INDEX}>
      {title && <Modal.Header status={status} title={title} />}
      {html && (
        <Modal.Body withCloseButton={!title}>
          {typeof html === 'string' ? (
            <Text span size="14px" lh="120%" truncate={false}>
              {html}
            </Text>
          ) : (
            // <br />태그를 포함할 땐 <Text />를 사용
            html
          )}
        </Modal.Body>
      )}
      <Modal.Footer>
        <Flex gap={8}>
          {showCancelButton && (
            <Button size="lg" variant="blue-transparent" onClick={onClose}>
              {cancelButtonLabel}
            </Button>
          )}
          {showConfirmButton && (
            <Button size="lg" variant={confirmButtonColor === 'red' ? 'red-filled' : 'blue-filled'} onClick={onConfirm}>
              {confirmButtonLabel}
            </Button>
          )}
        </Flex>
      </Modal.Footer>
    </Modal>
  );
};

export default Alert;
